import { CommentState, ICommentState } from "@/interfaces/comment.interface";
import { MetaInfoState } from "@/interfaces/meta.interface";
import { SetterOrUpdater } from "recoil";

export const parseManyComments = (
  parentComments: ICommentState[],
  setComments: SetterOrUpdater<CommentState>,
  setChildComments: SetterOrUpdater<CommentState>,
  setMeta: SetterOrUpdater<MetaInfoState>
) => {
  const meta: MetaInfoState = Object.fromEntries(
    parentComments
      ?.flatMap((comment) => comment.results)
      ?.flatMap((comment) => [comment, ...(comment?.children?.results ?? [])])
      ?.filter((e) => e)
      ?.map((comment) => ({
        fatherId: comment?.id,
        liked: comment?.liked,
        likedTime: comment?.likedTime,
      }))
      ?.map((meta) => [meta?.fatherId, meta]) ?? []
  );
  setMeta((prev) => ({ ...prev, ...meta }));
  const manyComments = Object.fromEntries(
    parentComments?.map((comments) => {
      const { results, count, fatherId } = comments;
      setChildComments((prev) =>
        Object.assign(
          {},
          prev,
          Object.fromEntries(
            results
              ?.filter((result) => result?.children?.count > 0)
              ?.map(({ id, children }) => [id, children]) ?? []
          )
        )
      );
      return [fatherId, { results, count }];
    }) ?? []
  );
  setComments((prev) => ({ ...prev, ...manyComments }));
};

export const parseChildCommentMeta = (
  comment: ICommentState,
  setChildComments: SetterOrUpdater<ICommentState>,
  setMeta: SetterOrUpdater<MetaInfoState>
) => {
  setMeta((prev) => ({
    ...prev,
    ...Object.fromEntries(
      comment?.results?.map((comment) => [
        comment?.id,
        {
          fatherId: comment?.id,
          liked: comment?.liked,
          likedTime: comment?.likedTime,
        },
      ]) ?? []
    ),
  }));
  setChildComments(comment);
};
